export const RestrictionsTypes = [
    { label: 'Availability', value: 'availability' },
    { label: 'Rate', value: 'rate' },
]